<template></template>

<script>
export default {
  data: function () {
    return {
      stripe: null,
      message:
        "You must have ApplePay activated to use this payment method. To activate please go to Settings > Wallet & Apple Pay on your device.",
      clientSecret: "",
      failedPayment: false,
    };
  },
  props: ["stripeKey", "amount", "paymentIntentUrl"],
  computed: {
    applePayEnabled: function () {
      if ($("#payment-request-button").is(":hidden")) {
        return false;
      }
    },
  },
  mounted() {
    this.stripe = Stripe(this.stripeKey);
    this.setUpApplePay();
  },
  watch: {},
  methods: {
    setUpApplePay() {
      this.stripe = Stripe(this.stripeKey);
      var paymentRequest = this.stripe.paymentRequest({
        country: "IE",
        currency: "eur",
        total: {
          label: "Motorcheck.ie Total",
          amount: this.amount * 100,
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });

      var elements = this.stripe.elements();
      var prButton = elements.create("paymentRequestButton", {
        paymentRequest: paymentRequest,
      });

      // Create a PaymentIntent and get the client secret
      axios
        .post(this.paymentIntentUrl)
        .then((response) => {
          this.clientSecret = response.data.client_secret;
        })
        .catch((error) => {
          console.log(error);
        });

      // Check the availability of the Payment Request API first.
      paymentRequest.canMakePayment().then(function (result) {
        result = true;
        if (result) {
          prButton.mount("#payment-request-button");
        } else {
          document.getElementById("payment-request-button").style.display =
            "none";
        }
      });

      let self = this;
      //   paymentRequest.on("token", function (ev) {
      //     // Send the token to your server to charge it!
      //     // Emit event so that parent component can record the transaction
      //     self.$emit("payment-completed", ev);
      //   });

      paymentRequest.on("paymentmethod", function (ev) {
        // Confirm the PaymentIntent without handling potential next actions (yet).
        self.stripe
          .confirmCardPayment(
            self.clientSecret,
            { payment_method: ev.paymentMethod.id },
            { handleActions: false }
          )
          .then(function (confirmResult) {
            if (confirmResult.error) {
              // Report to the browser that the payment failed, prompting it to
              // re-show the payment interface, or show an error message and close
              // the payment interface.
              ev.complete("fail");
            } else {
              // Report to the browser that the confirmation was successful, prompting
              // it to close the browser payment method collection interface.
              ev.complete("success");
              // Check if the PaymentIntent requires any actions and if so let Stripe.js
              // handle the flow
              if (confirmResult.paymentIntent.status === "requires_action") {
                // Let Stripe.js handle the rest of the payment flow.
                stripe
                  .confirmCardPayment(self.clientSecret)
                  .then(function (result) {
                    if (result.error) {
                      // The payment failed -- ask your customer for a new payment method.
                      self.failedPayment = true;
                    } else {
                      // The payment has succeeded.
                      self.$emit("payment-completed", ev);
                    }
                  });
              } else {
                // The payment has succeeded.
                self.$emit("payment-completed", ev);
              }
            }
          });
      });
    },
  },
  components: {},
};
</script>
